import { createFileRoute } from '@tanstack/react-router'
import { SettingsAIResponses } from '@/features/settings/ai-responses'

export const Route = createFileRoute('/_authenticated/settings/ai-responses')({
  component: SettingsAIResponses,
})
